export const STORAGE_KEY = {
  ACCESS: "accessToken",
  REFRESH: "refreshToken",
};

export const saveToken = (key, token) => localStorage.setItem(key, token);
export const getToken = (key) => localStorage.getItem(key);
export const removeToken = (key) => localStorage.removeItem(key);
